var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnplugged(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "svgFill",
    d: "M240.5 15.5a12 12 0 0 0-17 0L200 39l-2.5-2.5a36 36 0 0 0-51 0L124 59.1a12 12 0 0 0-16.5 17.4l72 72a12.1 12.1 0 0 0 17 0a12 12 0 0 0 .4-16.5l22.6-22.5a36 36 0 0 0 0-51L217 56l23.5-23.5a12 12 0 0 0 0-17Zm-38 77L180 115l-39-39l22.5-22.5a11.8 11.8 0 0 1 17 0l22 22a11.8 11.8 0 0 1 0 17Zm-54 47a12 12 0 0 0-17 0L120 151l-15-15l11.5-11.5a12 12 0 0 0-17-17L88 119l-11.5-11.5A12 12 0 0 0 59.1 124l-22.6 22.5a36 36 0 0 0 0 51L39 200l-23.5 23.5a12 12 0 0 0 0 17a12.1 12.1 0 0 0 17 0L56 217l2.5 2.5a36 36 0 0 0 51 0l22.5-22.6a11.7 11.7 0 0 0 8 3.1a12.2 12.2 0 0 0 8.5-3.5a12 12 0 0 0 0-17L137 168l11.5-11.5a12 12 0 0 0 0-17Zm-56 63a11.8 11.8 0 0 1-17 0l-22-22a11.8 11.8 0 0 1 0-17L76 141l39 39Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnplugged);
export default __webpack_public_path__ + "static/media/unplugged.fdeed7c8725a8877c5fdadb9cce3023a.svg";
export { ForwardRef as ReactComponent };